import {XauditModel} from '../xaudit.model';

export class InternalEmailDestinationDataModel extends XauditModel {
  IEmailToID: string;
  IEmailID: string;
  UserID: string;
  enumNotificationStatusID: string;
}
